<template>
  <div class="tool">
    <!-- 1.我提交的工单 -->
    <template v-if="isMySubmitOrder">
      <!-- 待处理 -->
      <template v-if="isAcceptStatus">
        <el-button type="danger" size="small" @click="handleClose"
          >关闭工单</el-button
        >
        <el-button type="primary" size="small" @click="handleTip"
          >催单</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 处理中 -->
      <template v-else-if="isProcessingStatus">
        <el-button type="danger" size="small" @click="handleClose"
          >关闭工单</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已处理 -->
      <template v-else-if="isWaitForFeedStatus">
        <el-button type="danger" size="small" @click="handleClose"
          >关闭工单</el-button
        >
        <el-button type="danger" size="small" @click="handleReject(false)"
          >重新处理</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已关闭 -->
      <template v-else-if="isCloseStatus">
        <el-button type="primary" size="small" @click="handleBack"
          >返回</el-button
        >
      </template>
    </template>

    <!-- 2.我受理的工单 -->
    <template v-else-if="isMyAcceptOrder">
      <!-- 待处理 -->
      <template v-if="isAcceptStatus">
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 处理中 -->
      <template v-else-if="isProcessingStatus">
        <el-button
          type="primary"
          size="small"
          @click="handleFeed"
          v-if="isHistory"
          >处理完毕</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已处理 -->
      <template v-else-if="isWaitForFeedStatus">
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已关闭 -->
      <template v-else-if="isCloseStatus">
        <el-button type="primary" size="small" @click="handleBack"
          >返回</el-button
        >
      </template>
    </template>

    <!-- 3.我关注的工单 -->
    <template v-else-if="isMyRelationShipOrder">
      <!-- 待处理 -->
      <template v-if="isAcceptStatus">
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 处理中 -->
      <template v-else-if="isProcessingStatus">
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已处理 -->
      <template v-else-if="isWaitForFeedStatus">
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已关闭 -->
      <template v-else-if="isCloseStatus">
        <el-button type="primary" size="small" @click="handleBack"
          >返回</el-button
        >
      </template>
    </template>

    <!-- 4.工单列表详情 -->
    <template v-else-if="isAllOrder">
      <!-- 待处理 -->
      <template v-if="isAcceptStatus">
        <el-button type="danger" size="small" @click="handleClose">
          关闭工单
        </el-button>
        <el-button type="primary" size="small" @click="handleTip"
          >催单</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
        >
          返回
        </el-button>
      </template>
      <!-- 处理中 -->
      <template v-else-if="isProcessingStatus">
        <el-button type="danger" size="small" @click="handleClose"
          >关闭工单</el-button
        >
        <el-button type="primary" size="small" @click="handleFeed"
          >处理完毕</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已处理 -->
      <template v-else-if="isWaitForFeedStatus">
        <el-button type="danger" size="small" @click="handleClose"
          >关闭工单</el-button
        >
        <el-button type="danger" size="small" @click="handleReject(false)"
          >重新处理</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已关闭 -->
      <template v-else-if="isCloseStatus">
        <el-button
          v-if="this.workOrder.handleResult !== 'NOT_PASS'"
          type="primary"
          size="small"
          @click="handleReopen"
          >重新打开</el-button
        >
        <el-button type="primary" size="small" @click="handleBack"
          >返回</el-button
        >
        <div
          v-if="this.workOrder.handleResult === 'NOT_PASS'"
          style="color: #e6a23c; margin-left: 10px; padding: 9px 15px"
        >
          注意：工单审批已被拒绝，不支持重新打开
        </div>
      </template>
    </template>

    <!-- 5.质检详情 -->
    <template v-else-if="isQualityOrder">
      <!-- 待处理 -->
      <template v-if="isAcceptStatus">
        <el-button type="danger" size="small" @click="handleClose"
          >关闭工单</el-button
        >
        <el-button type="primary" size="small" @click="handleTip"
          >催单</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 处理中 -->
      <template v-else-if="isProcessingStatus">
        <el-button type="danger" size="small" @click="handleClose"
          >关闭工单</el-button
        >
        <el-button type="primary" size="small" @click="handleFeed"
          >处理完毕</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已处理 -->
      <template v-else-if="isWaitForFeedStatus">
        <el-button type="danger" size="small" @click="handleClose"
          >关闭工单</el-button
        >
        <el-button type="danger" size="small" @click="handleReject(false)"
          >重新处理</el-button
        >
        <el-button
          class="last-button"
          type="primary"
          size="small"
          @click="handleBack"
          >返回</el-button
        >
      </template>
      <!-- 已关闭 -->
      <template v-else-if="isCloseStatus">
        <el-button
          v-if="this.workOrder.handleResult !== 'NOT_PASS'"
          type="primary"
          size="small"
          @click="handleReopen"
          >重新打开</el-button
        >
        <el-button type="primary" size="small" @click="handleBack"
          >返回</el-button
        >
        <div
          v-if="this.workOrder.handleResult === 'NOT_PASS'"
          style="color: #e6a23c; margin-left: 10px; padding: 9px 15px"
        >
          注意：工单审批已被拒绝，不支持重新打开
        </div>
      </template>
    </template>

    <!-- 6.我审批的工单 -->
    <template v-else-if="isMyApproveOrder">
      <el-button
        class="last-button"
        type="primary"
        size="small"
        @click="handleBack"
        >返回</el-button
      >
    </template>
    <el-dialog
      title="重新处理理由"
      :visible.sync="rejectDialog"
      width="30%"
      :before-close="handleCloseReject"
    >
      <div>
        <el-form
          :model="rejectForm"
          :inline="false"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="备注" prop="rejectRemark">
            <el-input
              style="width: 100%"
              :rows="7"
              v-model="rejectForm.rejectRemark"
              type="textarea"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <el-button type="" @click="handleCloseReject">取消</el-button>
          <el-button type="primary" @click="handleSaveRejectReason"
            >提交</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/plus/api";

export default {
  name: "workOrderTool",
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rejectDialog: false,
      rejectForm: {
        rejectRemark: "",
      },
      rules: {
        rejectRemark: [
          { required: true, message: "请输入备注", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    wkOrderId() {
      return this.workOrder.wkOrderId;
    },
    // 我提交的工单
    isMySubmitOrder() {
      return this.$route.name === "work.mySubmit.detail";
    },
    // 我审批的工单
    isMyApproveOrder() {
      return this.$route.name === "work.myApprove.detail";
    },
    // 我受理的工单
    isMyAcceptOrder() {
      return this.$route.name === "work.myAccept.detail";
    },
    // 我关注的工单
    isMyRelationShipOrder() {
      return this.$route.name === "work.relationship.detail";
    },
    // 工单列表详情
    isAllOrder() {
      return this.$route.name === "workmange.workOrderList.detail";
    },
    // 质检详情
    isQualityOrder() {
      return this.$route.name === "workmange.workQuality.detail";
    },

    // 待处理
    isAcceptStatus() {
      return this.workOrder && this.workOrder.status === 0;
    },
    // 已处理
    isWaitForFeedStatus() {
      return this.workOrder && this.workOrder.status === 1;
    },
    // 已关闭
    isCloseStatus() {
      return this.workOrder && this.workOrder.status === 2;
    },
    // 处理中
    isProcessingStatus() {
      return this.workOrder && this.workOrder.status === 4;
    },
    userType() {
      const userType = new Map([
        ["work.myAccept.detail", "ACCEPTOR"],
        ["work.mySubmit.detail", "AUTHOR"],
        ["workmange.workQuality.detail", "MANAGER"],
        ["workmange.workOrderList.detail", "MANAGER"],
      ]);
      return userType.get(this.$route.name);
    },
    isHistory() {
      return (
        this.workOrder &&
        this.workOrder.acceptUsers &&
        this.workOrder.acceptUsers.length > 0 &&
        this.workOrder.acceptUsers.some(
          (item) => item.userId === this.$store.state.userInfo.userId,
        )
      );
    },
  },
  methods: {
    //关闭工单
    handleClose() {
      this.$confirm(
        "关闭工单代表您对处理人的处理结果表示满意，若处理人未解决您的问题，请不要关闭工单。",
        "确认是否关闭工单",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "confirmBtn",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        },
      )
        .then(() => {
          api.work
            .closeWork({
              workOrderId: this.wkOrderId,
              optUserType: this.userType,
            })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("关闭成功！");
                this.$emit("refresh");
              }
            });
        })
        .catch((err) => {});
    },
    //返回
    handleBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        // 没有可返回页面时的处理
        this.$router.push("/work/index/homeIndex");
      }
    },
    //提醒
    handleTip() {
      api.workmanage
        .remind({
          workOrderId: this.wkOrderId,
          optUserType: this.userType,
        })
        .then((res) => {
          if (res.data.success) {
            this.$message.success("提醒成功！");
            this.$emit("refresh");
          }
        });
    },
    //重新处理
    handleReject(isAlreadyRemark) {
      if (this.workOrder.forceResp && !isAlreadyRemark) {
        this.rejectDialog = true;
        return;
      }
      this.$confirm(
        "工单状态会变为待处理，代表你对处理结果不满意，需要受理人重新处理，是否确定？",
        "确认是否重新处理",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "confirmBtn",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        },
      )
        .then(() => {
          api.work
            .reDealWorkOrder({
              workOrderId: this.wkOrderId,
              optUserType: this.userType,
              reprocessReason: this.workOrder.forceResp
                ? this.rejectForm.rejectRemark
                : "",
            })
            .then((res) => {
              if (res.data.success) {
                this.rejectForm.rejectRemark = "";
                this.$message.success("操作成功！");
                this.$emit("refresh");
              }
            });
        })
        .catch((err) => {
          this.rejectForm.rejectRemark = "";
        });
    },
    async handleSaveRejectReason() {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          this.rejectDialog = false;
          this.rejectReason = "";
          this.handleReject(true);
        }
      });
    },
    handleCloseReject() {
      this.$refs["ruleForm"].resetFields();
      this.rejectDialog = false;
    },
    //重新打开
    handleReopen() {
      this.$prompt("请输入重新打开的原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入重新打开的原因",
      })
        .then(({ value }) => {
          api.workmanage
            .reOpen({
              workOrderId: this.wkOrderId,
              openReason: value,
              optUserType: this.userType,
            })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("操作成功！");
                this.$emit("refresh");
              }
            });
        })
        .catch(() => {});
    },
    //处理完毕
    handleFeed() {
      const msg =
        this.workOrder.sourceChannel === "IM"
          ? "工单将关闭，"
          : "工单状态会变为已处理，";
      this.$confirm(
        `${msg}代表你已完全处理该工单问题，是否确定？`,
        "确认处理完毕",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "confirmBtn",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        },
      )
        .then(() => {
          api.work
            .myDealWorkOrder({
              workOrderId: this.wkOrderId,
              optUserType: this.userType,
            })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("操作成功！");
                this.$emit("refresh");
              }
            });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.tool {
  display: flex;
}
.last-button {
  margin-left: auto;
}
</style>
